export default "__VITE_ASSET__Ct0Te6j8__"